import React from 'react';
import Animated from 'react-native-reanimated';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { SCROLL_INDICATOR_INSETS } from 'design-system';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import NewsListItem from './NewsListItem';
import { useStockNews } from '../hooks/selectors';
import SetupInvestmentAccountButton from './SetupInvestmentAccountButton';
import { selectShowSetupInvestAccountInInvestScreens } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const NewsList = ({ assetId, onScroll }) => {
    /**
     * This will already contain previously fetched news, so the screen will already show something when user enters it.
     *
     * The news will always be unique in terms of `id` property.
     */
    const news = useStockNews(assetId);
    const showSetupInvestAccountInInvestScreens = useAppSelector(selectShowSetupInvestAccountInInvestScreens);
    const styles = useStyles(styleSet);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', showSetupInvestAccountInInvestScreens ? HEIGHT_PLUS_PADDING : 0, paddingHorizontalStyle);
    return (<>
      <Animated.FlatList data={news} onScroll={onScroll} style={styles.container} renderItem={NewsListItem} contentContainerStyle={contentContainerStyle} showsVerticalScrollIndicator scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>
      {showSetupInvestAccountInInvestScreens ? <SetupInvestmentAccountButton brand floating/> : null}
    </>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        flex: 1,
    },
}));
export default NewsList;
